import {
    VIEW_PROJECTS_BY_OPTION_SCHEMA,
    type SearchServiceViewProjectsByOption,
} from '../type/api';

/**
 * The options for the `viewProjectsBy` filter (professionals/architects).
 */
export const VIEW_PROJECTS_BY_OPTIONS = [
    {
        label: 'Our projects',
        value: 'our-projects',
    },
    {
        label: "Projects we're tagged in",
        value: 'projects-we-tagged-in',
    },
] as const satisfies readonly {
    label: string;
    value: SearchServiceViewProjectsByOption;
}[];

/**
 * The options for the `viewProjectsBy` filter including the combined "All"
 * option. Used for product suppliers who want to see all projects at once.
 */
export const VIEW_PROJECTS_BY_OPTIONS_WITH_ALL = [
    { label: 'All', value: 'all' } as const,
    ...VIEW_PROJECTS_BY_OPTIONS,
] satisfies readonly {
    label: string;
    value: SearchServiceViewProjectsByOption;
}[];

/**
 * Check if a string is a valid option for the `viewProjectsBy` filter.
 * @param value The string to check.
 * @returns The value if it is a valid option, `null` otherwise.
 */
export function validateViewProjectsBy(
    value?: string | null,
): SearchServiceViewProjectsByOption | null {
    if (!value) {
        return null;
    }
    const result = VIEW_PROJECTS_BY_OPTION_SCHEMA.safeParse(value);
    if (result.success) {
        return result.data;
    }
    return null;
}
